import { gql } from "@apollo/client";

export const VATFINANCING_INPUT_MUTATION = gql`
  mutation updateVatFinancing($input: VatFinancingInput) {
    updateVatFinancing(input: $input) {
      correlationId
    }
  }
`;
